import Vue from 'vue'
import App from './App.vue'

import router from './router'
// import 'element-ui/lib/theme-chalk/index.css';
import '../theme/index.css'
import ElementUI from 'element-ui';
import {Table,TableColumn,Pagination,DatePicker} from 'element-ui-old';
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

import VueResource from 'vue-resource';
import initCumstomComponents from './components'
import * as utils from './lib'
import {countryCode} from './lib/countryCode'
import categories from './lib/category'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import VueClipboard from 'vue-clipboard2'
import './main.css'
import htmlToPdf from './lib/pdf';

// editor
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

Vue.use(VueResource);
NProgress.configure({ trickleSpeed: 100 });
const cache = {};
cache.categories = categories;
Vue.prototype.$cache = cache;
Vue.prototype.$utils = utils;
Vue.prototype.$countryCode = countryCode;
Vue.prototype.$post = async function(){
	NProgress.remove();
	NProgress.start();
	NProgress.inc(0.5);
	const url = arguments[0];
	let isEdit = true;
	if(/list|detail/i.test(url)){
		isEdit = false;
	}
	try{
		const result = await Vue.http.post.apply(Vue.http,arguments);
		isEdit && this.$message({message:'Success!',type:'success',duration:1000})
		NProgress.done();
		return result.body;
	}catch(result){
		NProgress.done();
		this.$message({message:result.body,type:'error',duration:2000});
		if(/should\slogin/.test(result.body)){
			router.push({ path: 'login' });
		}
		throw result;
	}

	
}

Vue.prototype.$repeatPost = async function() {
	let result = {body:{}};
	while(!result.body.rows) {
		try{
			result = await Vue.http.post.apply(Vue.http,arguments);
		}catch(body){
			await new Promise(res => setTimeout(res, 1000));
		}
	}
	return result.body;
}

Vue.prototype.$getCsv = async function(link, post_data, file_name) {
	NProgress.start();
	NProgress.inc(0.5);
	const response = await this.$http.post(link, 
		post_data, 
		{responseType: 'arraybuffer'} 
	);
	NProgress.done();
	const blob = new Blob([response.data],{type:'text/csv'});
	const time = this.$utils.date_format((new Date()),'YYYY_MM_DD');
	// const file_name = 'API_' + time + '.csv';
	if(window.navigator.msSaveOrOpenBlob) {
		navigator.msSaveBlob(blob,file_name);
	} else {
		const a = document.createElement('a');
		a.download = file_name;
		a.href = window.URL.createObjectURL(blob);
		a.click();
	}

}

Vue.prototype.$validate = function(form){
	const self = this;
	return new Promise(function(res,rej){
		form.validate(async function (isValid, error) {
			if (isValid) {
				res(true);
			} else {
				const msg = [];
				Object.values(error).forEach(v => v.forEach(vv => msg.push(vv['message'])));
				self.$message({
					message: msg,
					type: 'error'
				});
				rej(false);
			}
		})
	})
}

locale.use(lang);
Vue.use(VueClipboard);
Vue.use(ElementUI, { locale });
Vue.use(Table,{ locale });
Vue.use(TableColumn,{ locale });
Vue.use(Pagination,{ locale });
Vue.use(DatePicker,{ locale });
Vue.use(htmlToPdf);
initCumstomComponents(Vue);


Vue.config.productionTip = false

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
